<template>
  <router-view />
</template>

<script setup>
import { onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

const store = useStore()
const router = useRouter()

// 应用启动时检查登录状态
onMounted(() => {
  // 检查登录状态是否有效
  if (store.getters.token) {
    store.dispatch('checkLoginStatus').then(isValid => {
      if (!isValid && router.currentRoute.value.path !== '/login') {
        ElMessage.warning('登录状态已过期，请重新登录')
        router.push('/login')
      }
    })
  }
})
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  height: 100%;
}

* {
  box-sizing: border-box;
}

/* 全局过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
